/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { getEntities as getPharmacyStockIndentItems } from 'app/entities/pharmacy-stock-indent-item/pharmacy-stock-indent-item.reducer';
import { PharmacyProductType } from 'app/shared/model/enumerations/pharmacy-product-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-stock-indent-map.reducer';

export const PharmacyStockIndentMapUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const pharmacyStockIndentItems = useAppSelector(state => state.pharmacyStockIndentItem.entities);
  const pharmacyStockIndentMapEntity = useAppSelector(state => state.pharmacyStockIndentMap.entity);
  const loading = useAppSelector(state => state.pharmacyStockIndentMap.loading);
  const updating = useAppSelector(state => state.pharmacyStockIndentMap.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyStockIndentMap.updateSuccess);
  const pharmacyProductTypeValues = Object.keys(PharmacyProductType);

  const handleClose = () => {
    navigate(`/pharmacy-stock-indent-map${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacies({}));
    dispatch(getPharmacyStockIndentItems({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.indentedQty !== undefined && typeof values.indentedQty !== 'number') {
      values.indentedQty = Number(values.indentedQty);
    }
    if (values.fulfilledQty !== undefined && typeof values.fulfilledQty !== 'number') {
      values.fulfilledQty = Number(values.fulfilledQty);
    }
    if (values.packs !== undefined && typeof values.packs !== 'number') {
      values.packs = Number(values.packs);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...pharmacyStockIndentMapEntity,
      ...values,
      requestingPharmacy: pharmacies.find(it => it.id.toString() === values.requestingPharmacy?.toString()),
      fulfillingPharmacy: pharmacies.find(it => it.id.toString() === values.fulfillingPharmacy?.toString()),
      indentItem: pharmacyStockIndentItems.find(it => it.id.toString() === values.indentItem?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          productType: 'CONSUMABLE',
          ...pharmacyStockIndentMapEntity,
          requestingPharmacy: pharmacyStockIndentMapEntity?.requestingPharmacy?.id,
          fulfillingPharmacy: pharmacyStockIndentMapEntity?.fulfillingPharmacy?.id,
          indentItem: pharmacyStockIndentMapEntity?.indentItem?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyStockIndentMap.home.createOrEditLabel" data-cy="PharmacyStockIndentMapCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentMap.home.createOrEditLabel">
              Create or edit a PharmacyStockIndentMap
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-stock-indent-map-id"
                  label={translate('tinyMedicRestApp.pharmacyStockIndentMap.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentMap.indentedQty')}
                id="pharmacy-stock-indent-map-indentedQty"
                name="indentedQty"
                data-cy="indentedQty"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentMap.fulfilledQty')}
                id="pharmacy-stock-indent-map-fulfilledQty"
                name="fulfilledQty"
                data-cy="fulfilledQty"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentMap.packs')}
                id="pharmacy-stock-indent-map-packs"
                name="packs"
                data-cy="packs"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentMap.productType')}
                id="pharmacy-stock-indent-map-productType"
                name="productType"
                data-cy="productType"
                type="select"
              >
                {pharmacyProductTypeValues.map(pharmacyProductType => (
                  <option value={pharmacyProductType} key={pharmacyProductType}>
                    {translate(`tinyMedicRestApp.PharmacyProductType.${pharmacyProductType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentMap.productId')}
                id="pharmacy-stock-indent-map-productId"
                name="productId"
                data-cy="productId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentMap.fromStockId')}
                id="pharmacy-stock-indent-map-fromStockId"
                name="fromStockId"
                data-cy="fromStockId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentMap.toStockId')}
                id="pharmacy-stock-indent-map-toStockId"
                name="toStockId"
                data-cy="toStockId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentMap.active')}
                id="pharmacy-stock-indent-map-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentMap.cursor')}
                id="pharmacy-stock-indent-map-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentMap.lastUpdated')}
                id="pharmacy-stock-indent-map-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentMap.microSec')}
                id="pharmacy-stock-indent-map-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyStockIndentMap.timestampEntry')}
                id="pharmacy-stock-indent-map-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="pharmacy-stock-indent-map-requestingPharmacy"
                name="requestingPharmacy"
                data-cy="requestingPharmacy"
                label={translate('tinyMedicRestApp.pharmacyStockIndentMap.requestingPharmacy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-stock-indent-map-fulfillingPharmacy"
                name="fulfillingPharmacy"
                data-cy="fulfillingPharmacy"
                label={translate('tinyMedicRestApp.pharmacyStockIndentMap.fulfillingPharmacy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-stock-indent-map-indentItem"
                name="indentItem"
                data-cy="indentItem"
                label={translate('tinyMedicRestApp.pharmacyStockIndentMap.indentItem')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyStockIndentItems
                  ? pharmacyStockIndentItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-stock-indent-map" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyStockIndentMapUpdate;
